import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-aldagi-footer',
  templateUrl: './aldagi-footer.component.html',
  styleUrls: ['./aldagi-footer.component.scss']
})
export class AldagiFooterComponent implements OnInit {
  @Input() baseUrl: string;
  constructor() {}
  toTop() {
    const element = document.getElementById('header');
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  ngOnInit() {}
}
